import { ReportedIssuesResponse } from '@/types/reportedIssues'
import { defineStore } from 'pinia'

interface States {
  reportedIssues: Ref<ReportedIssuesResponse | null>
}

export const useReportedIssuesStore = defineStore('reportedIssues', () => {
  const states: States = {
    reportedIssues: ref(null),
  }

  const resetStore = () => {
    states.reportedIssues.value = null
  }

  return {
    ...states,
    resetStore,
  }
})
